import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "order-detail-card"
};
var _hoisted_2 = {
  class: "header"
};
var _hoisted_3 = {
  class: "amount-info"
};
var _hoisted_4 = {
  class: "line"
};
var _hoisted_5 = {
  class: "label"
};
var _hoisted_6 = {
  class: "value"
};
var _hoisted_7 = {
  class: "line"
};
var _hoisted_8 = {
  class: "label"
};
var _hoisted_9 = {
  class: "value"
};
var _hoisted_10 = {
  class: "line"
};
var _hoisted_11 = {
  class: "label"
};
var _hoisted_12 = {
  class: "value"
};
var _hoisted_13 = {
  class: "line"
};
var _hoisted_14 = {
  class: "label"
};
var _hoisted_15 = {
  class: "value"
};
var _hoisted_16 = {
  class: "line"
};
var _hoisted_17 = {
  class: "label"
};
var _hoisted_18 = {
  class: "value van-multi-ellipsis--l2"
};
import { getDishOrderTypeMap, getPaymentMethodMapper } from "@/constant/order";
import { formatDateWithTZ } from "@/utils/format";
export default {
  __name: 'DishesOrderDetailCard',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      var _props$order$times, _props$order$payment;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("orderDetails")), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("orderID")), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(__props.order.id), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("orderTime")), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatDateWithTZ)((_props$order$times = __props.order.times) === null || _props$order$times === void 0 ? void 0 : _props$order$times.create_at)), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("orderType")), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(getDishOrderTypeMap)()[__props.order.type]), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("paymentMethod")), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(getPaymentMethodMapper)()[(_props$order$payment = __props.order.payment) === null || _props$order$payment === void 0 ? void 0 : _props$order$payment.payment_method]), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("remarks")), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(__props.order.remark || "-"), 1)])])]);
    };
  }
};